import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "originConnectionId", "appDataVersion", "portalId"];
import { addBaseMessageProperties } from './addBaseMessageProperties';
import { HEARTBEAT_REQUEST, REGISTER_PORT_CONNECTION_ACK } from './FromWorkerMessageTypes';
import { HEARTBEAT_RESPONSE, REGISTER_PORT_CONNECTION, UN_REGISTER_PORT_CONNECTION } from './ToWorkerMessageTypes';
import MessageChannelTypes from '../constants/MessageChannelTypes';

// TODO: New workers will no longer send this message it can eventually be cleaned up.
export const createHeartBeatResponseMessage = ({
  name,
  requestId,
  version
}) => Object.assign({}, addBaseMessageProperties({
  type: HEARTBEAT_RESPONSE,
  name,
  version
}), {
  destinationConnectionId: HEARTBEAT_REQUEST,
  responseRequest: {
    requestId
  }
});
export function createRegisterPortConnectionMessage(_ref) {
  let {
      name,
      originConnectionId,
      appDataVersion,
      portalId
    } = _ref,
    additionalProperties = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, addBaseMessageProperties({
    name,
    type: REGISTER_PORT_CONNECTION,
    version: appDataVersion
  }), {
    messageChannel: MessageChannelTypes.BROADCAST_MESSAGES,
    originConnectionId,
    responseRequest: {
      type: REGISTER_PORT_CONNECTION_ACK
    },
    payload: Object.assign({
      appDataVersion,
      // This never changes since the current bundles data version is static.
      portalId
    }, additionalProperties)
  });
}
export const createUnRegisterPortConnectionMessage = ({
  originConnectionId,
  appDataVersion,
  name
}) => {
  return Object.assign({}, addBaseMessageProperties({
    type: UN_REGISTER_PORT_CONNECTION,
    name,
    version: appDataVersion
  }), {
    originConnectionId,
    payload: {
      appDataVersion,
      name
    }
  });
};